export const DRAWER_HEADER_CLASSNAME = 'drawer-header';
export const DRAWER_HEADER_TITLE_CLASSNAME = 'drawer-header__title';
